<ng-template #confirmationModal let-modal>
    <div class="modal-head">
        <button class="btn btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
        <div class="img-wrap">
            <img src="./assets/images/ic-confirmation.svg" alt="Icon">
        </div>
        <h2 class="title-text" ngbAutofocus>Confirmation</h2>
        <h5 class="info-text">
            Business registration needs to be completed prior to adding images or products, do you confirm that the
            information
            entered is your
            correct business details
            (can be edited later)
        </h5>
        <div class="btn-grps">
            <button class="btn btn-outline-primary" title="Okay" (click)="okClicked();modal.close('Close click');">Okay</button>
        </div>
    </div>
</ng-template>